<template>
  <v-form
    ref="agentForm"
    @submit.prevent="submitForm"
    :style="{
      width: $vuetify.breakpoint.smAndUp ? '65%' : '100%'
    }"
  >
    <v-card-text>
      <v-text-field dense v-model="form.name" :rules="$rules.requiredRules" :label="$t('label.name')" class="text-field-styling w-100" outlined rounded readonly />
      <v-text-field dense v-model="form.email" :rules="$rules.emailRules" :label="$t('label.email')" class="text-field-styling w-100" outlined rounded readonly />
      <DOBPicker :label="$t('label.dob')" v-model="form.dob" class="text-field-styling" :rules="$rules.requiredRules" :disabled="dobEditable" />
      <div class="mb-4 px-6">
        <p class="mb-2">{{ $t('label.gender') }}</p>
        <v-radio-group v-model="form.gender" row class="mt-0" :rules="$rules.requiredRules">
          <v-radio :label="$t('label.male')" value="1"></v-radio>
          <v-radio :label="$t('label.female')" value="2"></v-radio>
        </v-radio-group>
      </div>
    </v-card-text>
    <v-card-actions class="d-flex flex-column align-stretch px-4">
      <v-btn color="primary" class="mx-5 mb-5 d-block rounded-pill green-gradient-right text-capitalize override-disabled-styles" type="submit">{{ $t('label.apply') }}</v-btn>
      <v-btn class="align-self-center primary--text" icon fab @click="$emit('prev-step')"><LeftArrow /></v-btn>
    </v-card-actions>
  </v-form>
</template>

<script>
import { mapMutations, mapState } from 'vuex'
import DOBPicker from '@/components/DOBPicker.vue'
import LeftArrow from '@/assets/icons/left-arrow-circle.svg'
import moment from 'moment'

export default {
  components: { DOBPicker, LeftArrow },
  data: () => ({
    form: {
      name: '',
      email: '',
      dob: '',
      gender: ''
    }
  }),
  mounted() {
    if (this.currentUser) {
      this.form.name = this.currentUser.full_name
      this.form.email = this.currentUser.email
      this.form.dob = this.currentUser.birthday ? moment(this.currentUser.birthday).format('YYYY-MM-DD') : ''
      this.form.gender = this.currentUser.gender === 'Female' ? '2' : this.currentUser.gender === 'Male' ? '1' : ''
      if (Object.keys(this.agentForm).length > 0) {
        this.form.dob = this.agentForm.birthday
        this.form.gender = this.agentForm.gender
      }
    }
  },
  computed: {
    ...mapState('auth', ['currentUser']),
    ...mapState('agent', ['agentForm', 'agentApplicationStatus']),
    dobEditable() {
      let status = false
      if (this.currentUser) status = this.agentApplicationStatus.status === 'Approved'
      return status
    }
  },
  methods: {
    ...mapMutations('agent', ['saveAgentForm']),
    submitForm() {
      if (!this.$refs.agentForm.validate()) {
        return true
      }
      this.saveAgentForm({ birthday: this.form.dob, gender: this.form.gender })
      this.$emit('next-step', this.form)
    }
  }
}
</script>

<style lang="scss" scoped>
::v-deep .dob-field .v-input__slot {
  padding: 0 24px !important;
}
</style>
